import React from 'react';
import { ButtonSecondary, Text } from '@spotify-internal/encore-web';

import { useTranslation } from 'providers/translations/TranslationProvider';

interface HelpfulPollProps {
  onYesClick: () => void;
  onNoClick: () => void;
}
const HelpfulPoll = ({ onYesClick, onNoClick }: HelpfulPollProps) => {
  const { t } = useTranslation();

  return (
    <>
      <ButtonSecondary size="small" onClick={onYesClick}>
        <Text variant="bodySmallBold">{t('yes')}</Text>
      </ButtonSecondary>{' '}
      <ButtonSecondary size="small" onClick={onNoClick}>
        <Text variant="bodySmallBold">{t('no')}</Text>
      </ButtonSecondary>
    </>
  );
};
export default HelpfulPoll;
